import { Box, Flex, Heading } from '@chakra-ui/react'
import { useStore } from '@contexts/store'
import { userWithoutToken } from '@helper/userWithoutToken'
import { DisplayUploadCareAsset } from '@hooks/useUploadCare'
import { ROUTES } from '@utils/routes'
import cn from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

const Logo: React.FC<
  React.AnchorHTMLAttributes<{}> & {
    width?: number
    height?: number
    showName?: boolean
  }
> = ({ className, href = ROUTES.HOME, width = 45, height = 45, ...props }) => {
  const router = useRouter()
  const { storeData, analytics, user } = useStore()
  const showName = storeData?.config?.storefront?.showNameWithLogo ?? true
  const widthFinal = width == 45 ? (showName ? width : [45, 125]) : width
  // console.log('widthFinal', widthFinal, width, showName)

  useEffect(() => {
    // Prefetch the checkout page
    router.prefetch(href)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigateHome = () => {
    if (href === ROUTES.HOME) {
      analytics.track('Home Clicked', userWithoutToken(user))
    }
  }

  return (
    <Box
      as={Link}
      onClick={navigateHome}
      href={href}
      cursor={'pointer'}
      className={cn('inline-flex focus:outline-none', className)}
      {...props}
    >
      <Flex align="center" columnGap={['0.5em', '1em']} direction={'row'}>
        {storeData?.logo_uuid && (
          <DisplayUploadCareAsset
            src={storeData?.logo_uuid}
            dimensions={{ width: widthFinal, height: height }}
            alt={`${storeData?.name} logo`}
            options={{ resize: `x720` }}
          />
        )}
        {showName || !storeData?.logo_uuid ? (
          <Heading
            as="h5"
            fontSize={{ base: '1em', md: '1.2em' }}
            fontWeight={{ base: 'semibold', md: 'bold' }}
            display={'block'}
            className="text-opacity-100"
            color={'primary'}
          >
            {storeData?.name}
          </Heading>
        ) : null}
      </Flex>
    </Box>
  )
}

export default Logo
